import { getRoutes} from '@/api/common'
import { getToken } from '@/utils/auth'

const loadView = (viewPath) => {
    return () => import(`@/views/${viewPath}`)
}

const filterAsyncRouter = (routerList) => {
    return routerList.filter(item => {
        if (item.component) {
            item.component = loadView(item.component)
        }
        if (item.children && item.children.length) {
            item.children = filterAsyncRouter(item.children)
        }
        return true
    })
}


const state = {
    token: getToken(),
    routeList: [],
    //userId: getUserId(),
    hasGetRoute:false
}

const mutations ={
    setRouteList(state, routeList) {
        state.routeList = filterAsyncRouter(JSON.parse(JSON.stringify(routeList)))
    },
    setHasGetRoute(state, hasGetRoute) {
        state.hasGetRoute = hasGetRoute
    },

}
//动态获取路由方式
const actions = {
    getRouteList({state,commit}) {
        return new Promise((resolve, reject) => {
            getRoutes().then(res => {
                let routeList = res.data
                commit('setRouteList', routeList)
                commit('setHasGetRoute', true)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
    resetRoute({ commit }){
        return new Promise(resolve => {
            commit('setRouteList', [])
            commit('setHasGetRoute', false)
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}